import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'

import { contractsQueryKey } from './useContracts'

// Hand-written until the OpenAPI types are regenerated.
export type ContractExtension = {
  id: string
  previous_end_date: string
  new_end_date: string
  notified: boolean
  created_at: string
  extended_by: string | null
}

// Nested under contractsQueryKey so extending a contract (which invalidates
// ['contracts']) refreshes the history too.
export function useContractExtensions(contractId?: string) {
  async function getContractExtensions() {
    const response = await apiClient.get<ContractExtension[]>(
      `${SNA_PREFIX}contracts/${contractId}/extensions`,
      { params: { type: 'offer' } }
    )
    return response.data
  }

  return useQuery({
    queryFn: getContractExtensions,
    queryKey: [...contractsQueryKey, 'extensions', contractId],
    enabled: !!contractId
  })
}
